import { GETREPORTUSER_SUCCESS, GETREPORTUSER_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const getReportUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETREPORTUSER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETREPORTUSER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getReportUserReducer;
